import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../spacesPlatform/utils/actionParams';

export interface IRunCreateExtractsOnDatasourcesParams extends IMultipleIdsParams {
  encrypt: boolean;
}

export class RunCreateExtractsOnDatasourcesRequest extends Request<IRunCreateExtractsOnDatasourcesParams, IResult> {
  constructor(ids: string[], encrypt: boolean) {
    super('runCreateExtractsOnDatasources', {
      ids: ids,
      encrypt: encrypt
    });
  }
}
